/**
 * API Configuration
 */

export const API_CONFIG = {
  baseURL: process.env.NEXT_PUBLIC_API_URL || "https://api.primes-cloud.co.kr",
  timeout: 30000, // 30 seconds
} as const;
